// Quick "Created" date chips with a persistent selected state, shared by the
// Leads list and the Pipeline/Kanban views so both behave identically.
export const DATE_CHIPS = [
  { key: "today", label: "Today", days: 0 },
  { key: "yesterday", label: "Yesterday", days: -1 },
  { key: "7d", label: "Last 7 days", days: 7 },
  { key: "30d", label: "Last 30 days", days: 30 },
];

// Compute an ISO {from,to} range for a chip (kept identical to the old inline logic).
export function computeDateRange(days) {
  const end = new Date();
  const start = new Date();
  if (days === 0) { start.setHours(0, 0, 0, 0); }
  else if (days === -1) { start.setDate(start.getDate() - 1); start.setHours(0, 0, 0, 0); end.setDate(end.getDate() - 1); end.setHours(23, 59, 59, 999); }
  else { start.setDate(start.getDate() - days); start.setHours(0, 0, 0, 0); }
  return { from: start.toISOString(), to: end.toISOString() };
}

// Best-effort: which chip (if any) matches a stored created_from value (by start day).
export function detectDateChip(createdFrom) {
  if (!createdFrom) return null;
  const fromDay = String(createdFrom).slice(0, 10);
  for (const c of DATE_CHIPS) {
    if (computeDateRange(c.days).from.slice(0, 10) === fromDay) return c.key;
  }
  return null;
}

export default function DateChips({ selected, onPick, onClear, hasDates, testid = "date-chips" }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testid}>
      <span className="text-[11px] font-medium text-ink/40">Created:</span>
      {DATE_CHIPS.map((d) => {
        const on = selected === d.key;
        return (
          <button
            key={d.key}
            data-testid={`date-chip-${d.key}`}
            aria-pressed={on}
            onClick={() => onPick(d.days, d.key)}
            className={`rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${on ? "border-navy bg-navy text-white" : "border-sky bg-white text-ink/70 hover:border-loop hover:text-loop"}`}
          >
            {d.label}
          </button>
        );
      })}
      {(hasDates || selected) && (
        <button data-testid="date-chip-clear" onClick={onClear} className="rounded-full px-2 py-1 text-xs font-medium text-red-500 hover:bg-red-50">Clear dates</button>
      )}
    </div>
  );
}
